import React, { useState, useEffect } from 'react';
import { BsPlusLg, BsPencil, BsPencilFill, BsStar, BsStarFill } from 'react-icons/bs';
import DetailsView from './DetailsView';
import MenuService from './MenuService';
import './ProductList.css'; // Import the CSS file

const ProductList = ({ handleAddToOrder, menuList, filterTxt, filterCategory, filterColor }) => {

    const [selectedItemIndex, setSelectedItemIndex] = useState(null);
    const [show, setShow] = useState(false);
    const [filteredMenuList, setFilteredMenuList] = useState(menuList);
    const [reviews, setReviews] = useState([]);
    const [inReviewMode, setInReviewMode] = useState(false);

    useEffect(() => {
        var flist = menuList.filter(item => {
            var productNumberStr = item.productNumber.toString();
            return (
                (filterTxt === '' || item.productName.toLowerCase().includes(filterTxt.toLowerCase()) || productNumberStr.includes(filterTxt)) &&
                (filterCategory === '' || item.categories.includes(filterCategory)) &&
                (filterColor === '' || item.type === filterColor)
            );
        });
        setFilteredMenuList(flist);
    }, [menuList, filterTxt, filterCategory, filterColor]);

    useEffect(() => {
        const menuService = new MenuService();
        menuService.getReviews().then(data => {
            if (data.reviews) {
                setReviews(data.reviews);
            }
        });
    }, []);

    const handleItemClick = (index, reviewMode = false) => {
        setSelectedItemIndex(index);
        setInReviewMode(reviewMode);
        setShow(true);
    };

    const handleCloseModal = () => {
        setSelectedItemIndex(null);
        setShow(false);
    };

    const handlePrevious = () => {
        setSelectedItemIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
    };

    const handleNext = () => {
        setSelectedItemIndex((prevIndex) => (prevIndex < filteredMenuList.length - 1 ? prevIndex + 1 : prevIndex));
    };

    const onAddToOrder = (product) => {
        handleAddToOrder(product);
    };

    const handleReviewUpdate = (review) => {
        const newReviews = [...reviews];
        const index = newReviews.findIndex((r) => r.productNumber === review.productNumber);
        if (index === -1) {
            newReviews.push(review);
        } else {
            newReviews[index] = review;
        }
        setReviews(newReviews);

        // save reviews to backend
        new MenuService().saveReviews(newReviews);
    }

    const handleReviewRemove = (review) => {
        const newReviews = [...reviews];
        const index = newReviews.findIndex((r) => r.productNumber === review.productNumber);
        if (index !== -1) {
            newReviews.splice(index, 1);
        }
        setReviews(newReviews);

        // save reviews to backend
        new MenuService().saveReviews(newReviews);
    }


    return (
        <div>
            {selectedItemIndex !== null && (
                <DetailsView
                    show={show}
                    handleCloseModal={handleCloseModal}
                    handlePrevious={handlePrevious}
                    handleNext={handleNext}
                    filteredMenuList={filteredMenuList}
                    selectedItemIndex={selectedItemIndex}
                    onAddToOrder={onAddToOrder}
                    menuList={menuList}
                    reviews={reviews}
                    updateReview={handleReviewUpdate}
                    removeReview={handleReviewRemove}
                    inReviewMode={inReviewMode}
                />
            )}

            <table className="table table-striped table-hover">
                <tbody>
                    {filteredMenuList.map((menu, index) => {
                        const review = reviews.find(review => review.productNumber === menu.productNumber);
                        return (
                            <tr key={menu.productNumber}>
                                <td className="col-sm-7">
                                    <a href="#" onClick={() => handleItemClick(index)} className="bold-link" >
                                        {menu.productNumber} - {menu.productName} { " > "}
                                    </a>
                                    &nbsp;
                                    {review && <span className="star-rating">
                                        {Array.from({ length: review.rating }, (_, i) => (
                                            <span key={i}>&#9733;</span>
                                        ))}
                                    </span>}
                                    &nbsp;
                                    {menu.outOfStock === 'True' ? (
                                        <span className="badge bg-danger">Uitverkocht</span>
                                    ) : ("")}
                                    <br />
                                </td>

                                <td className="col-sm-1">{parseFloat(menu.price).toFixed(2)}€<br /></td>
                                <td className="col-sm-1">
                                    {menu.outOfStock === 'True' ? (
                                        ""
                                    ) : (
                                        <button
                                            type="button"
                                            className="btn btn-outline-success"
                                            onClick={() => onAddToOrder(menu)}
                                        >
                                            <BsPlusLg />
                                        </button>
                                    )}
                                    {review ? (

                                        <button
                                            type="button"
                                            className="btn btn-outline-success"
                                            onClick={() => handleItemClick(index, true)}
                                        >
                                            <BsStarFill />
                                        </button>
                                    ) : (
                                        <button
                                            type="button"
                                            className="btn btn-outline-success"
                                            onClick={() => handleItemClick(index, true)}
                                        >
                                            <BsStar />
                                        </button>
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div >
    );
};

export default ProductList;